import { useSelector } from 'react-redux';

import { Link } from "../utils/components/router";

export default function PageNotFound() {
  const configStorage = useSelector(store => store.configStorage);
  const contextRoot = configStorage.getContextRoot();
  return (
    <div>
      <h2>Seite nicht gefunden!</h2>
      <p>
        <Link to={contextRoot}>Zur Startseite</Link>
      </p>
    </div>
  );
}
